// @ts-ignore
import { getTemplate } from '@progress/kendo-vue-common';
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
/**
 * @hidden
 */
var TabStripNavigationItemVue2 = {
  name: 'KendoTabStripNavigationItem',
  // @ts-ignore
  emits: {
    select: null
  },
  props: {
    active: Boolean,
    disabled: Boolean,
    index: Number,
    title: {
      type: String,
      default: 'Untitled'
    },
    titleRender: [String, Function, Object],
    first: {
      type: Boolean,
      default: undefined
    },
    last: {
      type: Boolean,
      default: undefined
    }
  },
  computed: {
    itemClasses: {
      get: function get() {
        var _a;
        var _b = this.$props,
          active = _b.active,
          disabled = _b.disabled,
          first = _b.first,
          last = _b.last;
        return _a = {}, _a['k-first'] = first, _a['k-last'] = last, _a['k-item'] = true, _a['k-disabled'] = disabled, _a['k-active'] = active, _a;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      if (!this.$props.disabled) {
        this.$emit('select', this.$props.index);
      }
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  render: function render(createElement) {
    var h = gh || createElement;
    var _a = this.$props,
      active = _a.active,
      _b = _a.title,
      title = _b === void 0 ? 'Untitled' : _b;
    var titleRender = this.$props.titleRender;
    var titleElement = getTemplate.call(this, {
      h: h,
      template: titleRender,
      defaultRendering: title,
      additionalProps: this.$props,
      additionalListeners: {
        select: this.onClick
      }
    });
    return h("li", {
      "aria-selected": active,
      attrs: this.v3 ? undefined : {
        "aria-selected": active,
        role: 'tab'
      },
      role: 'tab',
      onClick: this.onClick,
      on: this.v3 ? undefined : {
        "click": this.onClick
      },
      "class": this.itemClasses
    }, [h("span", {
      "class": "k-link"
    }, [titleElement])]);
  }
};
/**
 * @hidden
 */
var TabStripNavigationItem = TabStripNavigationItemVue2;
export { TabStripNavigationItem, TabStripNavigationItemVue2 };